import {platformAPI} from "../../../api/axiosConfig";

export type SirenSMSConfig = {
    id: string;
    clientID?: string;
    departmentID?: string;
    sirenRecipientPortalURL: string;
    introductoryMessage: string;
    smsOptInExemptions: string[];
    updatedBy: string;
    updatedAt: string;
};

export async function getSirenSMSConfigExact(params: {clientID?: string; departmentID?: string}): Promise<SirenSMSConfig | null> {
    try {
        const res = await platformAPI.get<SirenSMSConfig>("api/siren/sms-config/exact", {params});
        return res.data;
    } catch {
        return null;
    }
}
